<template>
  <div>
    <v-row class="justify-center">
      <v-col cols="12" class="pa-0">
        <v-footer color="#fff" class="footer">
          <v-container fluid>
            <v-row align="center" justify="center" class="pa-2">
             
              <v-col class="text-center d-flex justify-center" cols="12" >
                <img
                  class="logo-img"
                  src="@/assets/img/logo-gob.svg"
                  alt="Logo de Gobierno"
                />
              </v-col>
              
            </v-row>
          </v-container>
        </v-footer>
      </v-col>
    </v-row>
    <!-- <v-row class="justify-center">
      <v-col cols="12" sm="4" class="d-flex justify-center" style="gap: 20px">
        <v-btn icon @click="redirectTo('https://www.facebook.com/PresidenciaSV/?locale=es_LA')" >
          <v-img class="mx-3 " src="@/assets/img/icons/Facebook-color.svg" width="40"/>
        </v-btn>
        <v-btn icon @click="redirectTo('https://twitter.com/i/flow/login?redirect_after_login=%2FPresidenciaSV')">
          <v-img src="@/assets/img/icons/twitter-x-color.svg" width="30" class="mx-3 color-logo"/>
        </v-btn>
        <v-btn icon @click="redirectTo('https://www.youtube.com/@GobiernoSV/videos')">
          <v-img src="@/assets/img/icons/youtube-color.svg" width="30" class="mx-3"/>
        </v-btn>
      </v-col>
    </v-row> -->
  </div>

</template>

<script>
export default {
  methods: {
    redirectTo(link) {
      window.open(link, '_blank');
    },
  }
}
</script>
<style scoped>
.footer {
  flex-shrink: 0;
  background-color: #fff;
  box-shadow: none;
  margin-top: auto;
  width: 100%;
}

.v-sheet.v-footer:not(.v-sheet--outlined) {
  box-shadow: none;
  margin-top: 2rem !important;
}

.logo-img {
  max-width: 100%;
  height: auto;
  width: 280px;
  margin: 1rem 0;
  object-fit: contain;
}

/* Small devices (landscape phones, 576px and up) */
@media only screen and (min-width: 576px) {
  .logo-img {
    width: 320px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .logo-img {
    width: 350px;
  }
}

/* Large devices (desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .logo-img {
    width: 380px;
  }
}
</style>
